import TableFilters from '@/components/elements/table/filters';

export default {
    components: { TableFilters },

    data() {
        return {
            filters: {},
        };
    },

    methods: {
        searchMatched(values, data) {
            if (!this.filters.search) {
                return true;
            }

            let matched = false;
            values.forEach(value => {
                // If we already have a true value, no need to look for another
                if (matched) {
                    return;
                }

                let property = data;
                value.split('.').forEach(key => {
                    property = property[key];
                });

                if (typeof property !== 'string') {
                    return;
                }

                matched = property.toLowerCase().includes(this.filters.search.value.toLowerCase());
            });

            return matched;
        },

        isValidSelection(name, data) {
            let isNested = name.includes('.$.');
            if (!this.filters[name] && !isNested) {
                return true;
            }
            if (!isNested) {
                return this.filters[name].selected.includes(data) || this.filters[name].selected.length === 0;
            }

            let parts = name.split('.$.');

            return data[parts[0]].filter((d) =>
                this.filters[parts[1]].selected.includes(d[parts[1]])
            ).length || this.filters[parts[1]].selected.length === 0;
        },

        isValidDate(name, data_date) {
            if (!this.filters[name]) {
                return true;
            }

            if (!this.filters[name].selected.startDate || !this.filters[name].selected.endDate) {
                return true;
            }

            const date = this.$moment(data_date);
            const start = this.$moment(this.filters[name].selected.startDate).startOf('day');
            const end = this.$moment(this.filters[name].selected.endDate).endOf('day');

            return date.isBetween(start, end) || date.isSame(start, 'day') || date.isSame(end, 'day');
        },
    },
};
